<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-07 19:35:47
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-08 16:44:11
 * @FilePath: /chaoyongtuan/src/views/shopManage/shopLibrary/addMaterial/components/local/tableCells/opeatorCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div>
			<el-button size="mini" type="text" @click="updateTableData(row, 'remove')" style="padding-bottom: 0">移除</el-button>
		</div>
		<div v-if="!column.isBatch" style="line-height: 20px">
			<el-button size="mini" type="text" @click="cancelTop(row)" style="padding-top: 0" v-if="row.isTop == 1">取消置顶</el-button>
			<el-button size="mini" type="text" @click="toTop(row)" style="padding-top: 0" v-else>置顶</el-button>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';

export default {
	mixins: [mixin],
	data() {
		return {};
	},
    inject: {
		injectUpdateTableData: {
			default: () => {
				return () => {};
			},
		},
        injectCancelTop: {
			default: () => {
				return () => {};
			},
		},
		injectToTop: {
			default: () => {
				return () => {};
			},
		},
	},
	components: {},
	computed: {},
	props: {},

	mounted() {},

	methods: {
        updateTableData(row){
            this.injectUpdateTableData(row, 'remove')
        },
        cancelTop(row){
            console.log(1121321)
            this.injectCancelTop(row)
        },
        toTop(row){
            console.log(223232)
            this.injectToTop(row)
        }
    },
};
</script>
<style lang="less" scoped></style>
